import { useLocation, useNavigate, useResolvedPath } from "react-router-dom";
import { Flex, Tabs } from "antd";
import { ScanBox, Group, Variable, ScanSquare } from "lucide-react";

const TABS = [
    { slug: "entity", label: "Сущности", icon: <ScanBox size={15}/> },
    { slug: "parameters", label: "Параметры", icon: <ScanSquare size={15}/> },
    { slug: "group-parameters", label: "Группы параметров", icon: <Group size={15}/> },
];

export default function TopTabs({ base = "/content" }) {
    const resolved = useResolvedPath(base).pathname;
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const activeTab =
        TABS.find((tab) => pathname === `${resolved}/${tab.slug}` || pathname.startsWith(`${resolved}/${tab.slug}/`))?.slug ??
        TABS[0].slug;

    const items = TABS.map((tab) => ({
        key: tab.slug,
        label: (
            <span className="flex gap-1">
                {tab.icon && <span className="">{tab.icon}</span>}
                <span>{tab.label}</span>
            </span>
        ),
        children: null,
    }));

    return (
        <Flex vertical gap="middle" className="ml-4">
            <Tabs
                activeKey={activeTab}
                onChange={(key) => navigate(`${resolved}/${key}`)}
                items={items}
                className=""
            />
        </Flex>
    );
}